<template lang="pug">
  router-link.block.hover-text-app-text.active-text-app-accent.focus-text-app-accent(:to="rt(doc)", v-if="doc.handle")
    article
      figure.relative.pb-ar-2x3.bg-gray-200
        resp-img-shopify(:bg="true", :image="imgs(doc)[0]", v-if="visible && imgs(doc)[0]")
        //- img.absolute.overlay.object-cover.object-center.transition-opacity.duration-150(v-for="(img, i) in imgs(doc)", v-if="!i", :src="visible && img.transformedSrc", :alt="img.altText", @load="imgLoaded = true", :class="{'opacity-0': !imgLoaded}")
      header.text-13.mt-24
        h6 {{ doc.vendor }}
        h4 {{ doc.title.replace(doc.vendor + ' ', '') }}
        div {{ color(doc) }}
        div(v-if="!priceHidden")
          product-price(:isSoldOut="doc.availableForSale === false", :amount="doc.priceRange.minVariantPrice.amount")
</template>

<script>
import { mapGetters } from 'vuex'
import ProductPrice from './ProductPrice'
import RespImgShopify from './RespImgShopify'
import get from 'lodash/get'
export default {
  name: 'ProductThumb',
  props: {
    doc: { type: Object, default: () => ({}) },
    visible: { type: Boolean, default: true }
  },
  data () {
    return {
      imgLoaded: false
    }
  },
  computed: {
    ...mapGetters({ frmtPrice: 'shop/price' }),
    priceHidden () {
      return this.doc.metafields.edges.find(edge => edge.node.key === 'price_hidden')
    }
  },
  methods: {
    rt (doc) {
      const rt = { name: 'product', params: { handle: doc.handle } }
      if (this.$route.params.collection) {
        rt.name = 'collection_product'
        rt.params.collection = this.$route.params.collection
      }
      return rt
    },
    imgs (doc) {
      return (doc.images && doc.images.edges.map(itm => itm.node)) || []
    },
    color (doc) {
      const options = get(doc, 'variants.edges[0].node.selectedOptions') || []
      const color = options.find(opt => ['color', 'colour'].includes(opt.name.toLowerCase()))
      return color && color.value
    }
  },
  components: { ProductPrice, RespImgShopify }
}
</script>

<style>
</style>
